<template>
    <v-stepper :value="step">
        <v-stepper-header>
            <v-stepper-step step="1" :complete="step > 1">
                {{ $t('bulk_orders_import.stepper.upload_file') }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="step > 2">
                {{ $t('bulk_orders_import.stepper.check_statistics') }}
            </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
            <v-stepper-content step="1">
                <create-bulk-order-import-form
                    :warehouse-id="warehouseId"
                    @onSubmit="onFormSubmit"
                />
            </v-stepper-content>
            <v-stepper-content step="2">
                <create-bulk-order-import-summary
                    v-if="step === 2"
                    :import-id="importId"
                    @onConfirm="onConfirm"
                />
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import CreateBulkOrderImportForm from "@/components/user/bulkOrdersImport/CreateBulkOrderImportForm.vue";
import CreateBulkOrderImportSummary from "@/components/user/bulkOrdersImport/CreateBulkOrderImportSummary.vue";

export default {
    name: "CreateBulkOrderImportStepper",
    components: {CreateBulkOrderImportSummary, CreateBulkOrderImportForm},
    props: {
        warehouseId: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        // loading
        isBusySubmit: false,
        // stepper
        step: 1,
        // import ID
        importId: null
    }),
    computed: {
        isBusy() {
            return this.isBusySubmit;
        }
    },
    methods: {
        onFormSubmit(importId) {
            this.importId = importId
            this.step += 1;
        },
        onConfirm() {
            this.step = 1;
            this.$emit("onClose");
        }
    }
}
</script>
